import React from 'react'
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom'

import ROUTES from './constants/routes'
import SearchBar from './pages/SearchBar'
import Tracking from './pages/Tracking'
import './App.css'

const App: React.FC = () => (
  <div className="App">
    <Router>
      <Switch>
        <Route exact path="/">
          <Redirect to={ROUTES.SEARCH} />
        </Route>
        <Route path={ROUTES.SEARCH} component={SearchBar} />
        <Route path={ROUTES.TRACKING} component={Tracking} />
      </Switch>
    </Router>
  </div>
)

export default App
